import React from "react";
import CommissaryEmployeeLayout from "../../layout/CommissaryEmployeeLayout";
import { Typography } from "antd";

const HomeEmployee = () => {
  return (
    <CommissaryEmployeeLayout>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          // border: "1px solid red",
          height: "100%",
        }}
      >
        <Typography style={{ fontSize: 24 }}>
          Please ask for your permission
        </Typography>
        <Typography>This is only a landing page for employee</Typography>
      </div>
    </CommissaryEmployeeLayout>
  );
};

export default HomeEmployee;
